import { useSelector } from "react-redux";
import { selectCanUseGrow, selectClinicId } from "../../store/slices/authSlice";
import { useGetTransactionByAppointmentQuery } from "../../store/services/financeApi";
import useGrowLinksMap from "./useGrowLinksMap";
import GrowLinkStatusChip from "./GrowLinkStatusChip";
import RequestPaymentButton from "./RequestPaymentButton";
import "./GrowLinks.css";

const PAID_FAMILY = ["paid", "invoice_manual", "invoice_auto"];

/**
 * GrowAppointmentPayment — compact Grow control for ONE appointment (wizard
 * summary footer / classic modal). Resolves the appointment's transaction,
 * then shows the link chip (any state) or a "בקשת תשלום" button when the
 * transaction is unpaid. Renders nothing when: user cannot use Grow, the
 * appointment is new (no id), no transaction exists yet, or the transaction is
 * already paid without a Grow link.
 *
 * Props: appointment ({id, patientId}), size? ("sm"|"md")
 */
export default function GrowAppointmentPayment({ appointment, size = "sm", className = "" }) {
  const clinicId = useSelector(selectClinicId);
  const canUseGrow = useSelector(selectCanUseGrow);
  const appointmentId = appointment?.id || null;

  const { data: transaction } = useGetTransactionByAppointmentQuery(
    { clinicId, appointmentId },
    { skip: !clinicId || !appointmentId || !canUseGrow }
  );
  const growLinks = useGrowLinksMap(transaction ? [transaction] : []);

  if (!canUseGrow || !transaction) return null;
  const link = growLinks.linkFor(transaction);
  const unpaid = !PAID_FAMILY.includes(transaction.status) && !["split", "refunded", "cancelled"].includes(transaction.status);

  if (!link && !unpaid) return null;

  return (
    <div className={`grow-inline-row ${className}`.trim()}>
      {link ? (
        <GrowLinkStatusChip link={link} size={size === "md" ? "sm" : "xs"} onClick={() => growLinks.openLink(link)} />
      ) : (
        <RequestPaymentButton transactions={[transaction]} size={size} variant="secondary" label="דרישת תשלום Grow" />
      )}
      {growLinks.popover}
    </div>
  );
}
